import { getLocalApi } from "./localApi";
import { BookingSystem } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllBookingSystems2() : Promise<BookingSystem[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_booking_systems, (dto: any) => {
        const rawId = dto.id;
        const id = typeof rawId === "string" && /^BookingSystem-/i.test(rawId)
            ? rawId
            : rawId != null ? `BookingSystem-${rawId}` : "";
        return { name: dto.name ?? id, id };
    }, 'Unable to fetch booking systems');
}

export async function getAllBookingSystems() : Promise<BookingSystem[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_booking_systems, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch booking systems');
}

export interface ProductOfferingExclusionsResponse {
    schoolId: number;
    productTypeId: number;
    productId: number;
    excludedBookingSystemIds: number[];
}

const fmt = (tpl: string, p: Record<string, string | number>) =>
    Object.keys(p).reduce((s, k) => s.replaceAll(`{${k}}`, String(p[k])), tpl);

export async function getProductOfferingExclusions(
    schoolId: number,
    productTypeId: number,
    productId: number
): Promise<ProductOfferingExclusionsResponse> {
    const localApi = await getLocalApi();

    const url = fmt(apiConfig.booking_system_exclusion_get_product_offering, {
        schoolId,
        productTypeId,
        productId,
    });

    return await localApi.fetchSingle<ProductOfferingExclusionsResponse>(
        url,
        (dto: any) => ({
            schoolId: dto.schoolId ?? dto.SchoolId ?? schoolId,
            productTypeId: dto.productTypeId ?? dto.ProductTypeId ?? productTypeId,
            productId: dto.productId ?? dto.ProductId ?? productId,
            excludedBookingSystemIds: dto.excludedBookingSystemIds ?? dto.ExcludedBookingSystemIds ?? [],
        }),
        "Unable to fetch exclusions"
    );
}

export async function setProductOfferingExclusions(
    schoolId: number,
    productTypeId: number,
    productId: number,
    bookingSystemIds: number[]
): Promise<{ ok: boolean; message?: string }> {
    const localApi = await getLocalApi();

    const url = fmt(apiConfig.booking_system_exclusion_set_product_offering, {
        schoolId,
        productTypeId,
        productId,
    });

    const res = await localApi.call(url, "PUT", JSON.stringify({ bookingSystemIds }));

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        return { ok: false, message: text || `Failed (${res.status})` };
    }

    return { ok: true };
}
